import Typography from '@mui/material/Typography';
import React, { useState } from "react";
import styles from './SmartText.module.css';


const SmartText = ({ text, length = 20 }) => {
    const [showLess, setShowLess] = useState(true);
  
    if (text.length < length) {
      return <Typography sx={{mt: 2}}>{text}</Typography>;
    }
  
    return (
      <div>
        <Typography sx={{mt: 2}}>{ showLess ? `${text.slice(0, length)}...` : text }</Typography>
        <Typography
          style={{ color: "black", cursor: "pointer", textDecoration: 'underline'}}
          className={styles.readMoreLess}
          onClick={() => setShowLess(!showLess)}
        >
          &nbsp;View {showLess ? "More" : "Less"}
        </Typography>
      </div>
    );
  };


  export default SmartText;